import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BusinessCard from '../components/BusinessCard';
import { useWishlist } from '../context/WishlistContext';
import { Heart, Sparkles, Trash2 } from 'lucide-react';

export default function PreferitePage() {
  const { items, clear, count } = useWishlist();

  return (
    <div style={{ backgroundColor: 'var(--mi-bg)', minHeight: '100vh' }}>
      <Header />

      <div className="mi-container py-10 md:py-16">
        <div className="flex items-end justify-between mb-8">
          <div>
            <p className="text-xs uppercase tracking-widest font-medium mb-1" style={{ color: 'var(--mi-accent)' }}>
              Le tue scelte
            </p>
            <h1 className="font-display text-3xl md:text-4xl" style={{ color: 'var(--mi-fg)' }}>
              Preferiti
            </h1>
            {count > 0 && (
              <p className="text-sm mt-1" style={{ color: 'var(--mi-text)' }}>
                {count} {count === 1 ? 'attività salvata' : 'attività salvate'}
              </p>
            )}
          </div>
          {count > 0 && (
            <button
              onClick={() => { if (window.confirm('Svuotare i preferiti?')) clear(); }}
              className="flex items-center gap-2 px-4 py-2 rounded-xl border text-sm font-medium transition-all hover:border-red-300 hover:text-red-500"
              style={{ borderColor: 'var(--mi-border)', color: 'var(--mi-text)' }}
            >
              <Trash2 size={14} />
              Svuota
            </button>
          )}
        </div>

        {count === 0 ? (
          <div className="text-center py-24">
            <Heart
              size={56}
              className="mx-auto mb-5"
              style={{ color: 'var(--mi-border)' }}
            />
            <h2 className="font-display text-2xl mb-3" style={{ color: 'var(--mi-fg)' }}>
              Nessun preferito ancora
            </h2>
            <p className="text-sm mb-8" style={{ color: 'var(--mi-text)' }}>
              Esplora le attività e salva quelle che ti interessano.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/scopri"
                className="btn-gold inline-flex items-center gap-2 px-6 h-11 rounded-xl text-sm font-semibold"
              >
                <Sparkles size={15} />
                Scopri le attività
              </Link>
              <Link
                to="/attivita"
                className="inline-flex items-center gap-2 px-6 h-11 rounded-xl text-sm font-medium border transition-all hover:bg-white hover:border-[var(--mi-accent)]"
                style={{ borderColor: 'var(--mi-border)', color: 'var(--mi-fg)' }}
              >
                Sfoglia il catalogo
              </Link>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {items.map((business) => (
              <BusinessCard key={business._id} business={business} />
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
